<template>

    <m-edit1/>

    <m-brands-300 v-bind='{...{},...{}}' :style='""' class="" ></m-brands-300>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mBrands300 from '@moeinmdn/miw-alpha-components/src/package/Brand/Brands/Brands300';

export default {
    name: 'HomeView',
    components: {mEdit1, mBrands300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
